import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
type ProgressState = { show: boolean, progressingText?: string };

@Injectable({
  providedIn: 'root'
})



export class ProgressingService {

  progressing$ = new BehaviorSubject<ProgressState>({show:false,progressingText:"Processing"});
  constructor() { }

  getProgressingLoader() {
    return this.progressing$;
  }
  
  show(show = true,progressingText?) {
    this.progressing$.next({show:show,progressingText:progressingText??"Processing"});
  }

  hide() {
    this.progressing$.next({show:false});
  }

  listenObservable(observable$: Observable<unknown>) {
    if(observable$) {
      this.progressing$.next({show:true,progressingText:"Processing"});
      const handler = (sub) => {
        this.progressing$.next({show:false});
        if(sub) {
          sub.unsubscribe();
        }
      }

      // note: observable$.pipe(finalize( ()=>{})) // this cannot handle error case
      const sub = observable$.subscribe({
        next: () => handler(sub),
        error: () => handler(sub),
        complete: () => handler(sub)
      });
    }
  }

  listenPromise(aPromise: Promise<unknown>) {
    if(aPromise) {
      this.progressing$.next({show:true,progressingText:"Processing"});
      aPromise.finally(() => this.progressing$.next({show:false}))
    }
  }

  
}
